import { useState, useEffect } from "react";
import styles from "./Nav.module.css";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const navLinks = [
    { href: "#about",    label: "About"    },
    { href: "#services", label: "Services" },
    { href: "#products", label: "Products" },
    { href: "#contact",  label: "Contact"  },
  ];

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ""}`}>
      <a href="#" className={styles.logo} aria-label="Carrcraft Studio home">
        Carrcraft<span className={styles.dot}>.</span>
      </a>

      {/* Desktop links */}
      <ul className={styles.links} role="list">
        {navLinks.map((l) => (
          <li key={l.href}>
            <a href={l.href} className={styles.link}>
              {l.label}
            </a>
          </li>
        ))}
      </ul>

      <a href="mailto:info@carrcraft.com.au" className={styles.cta}>
        Get in Touch
      </a>

      {/* Mobile hamburger */}
      <button
        className={styles.burger}
        onClick={() => setMenuOpen((v) => !v)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span className={`${styles.bar} ${menuOpen ? styles.barOpen1 : ""}`} />
        <span className={`${styles.bar} ${menuOpen ? styles.barOpen2 : ""}`} />
        <span className={`${styles.bar} ${menuOpen ? styles.barOpen3 : ""}`} />
      </button>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className={styles.drawer}>
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={styles.drawerLink}
              onClick={() => setMenuOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <a
            href="mailto:info@carrcraft.com.au"
            className={styles.drawerCta}
            onClick={() => setMenuOpen(false)}
          >
            Get in Touch
          </a>
        </div>
      )}
    </nav>
  );
}
